'use client';

import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { Currency } from 'utils/Currency';
import { CurrencySymbol, useFormatPrice } from 'hooks/pricing/useFormattedPrice';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { useCartStore, useShallow } from 'components/shared/Cart';
import { CustomImage } from '../custom-image';
import { RespiratoryShopifyMap } from 'content/products/addons/respiratory';

import {
  ImageContainer,
  InfoModalContainer,
  InfoModalDescription,
  InfoModalTitle,
  PricingModal,
} from './layout';

export const RespiratoryCartInfoModal = () => {
  const t = useTranslations('ring');
  const CartClient = useCartStore(
    useShallow((s) => ({ store: s.store, currency: s.currency })),
  );
  const searchParams = useSearchParams();
  const formatPriceWithComma = useFormatPrice();

  const { store, currency } = CartClient;
  const isRespiratoryFlow = searchParams?.get('flow') === 'respiratory';
  const CurrencyCode = CurrencySymbol[currency ?? Currency.usd];

  return (
    <InfoModalContainer>
      <InfoModalTitle>
        <h3>{t('ring.infoModals.respiratory.title')}</h3>
        <p>
          {!isRespiratoryFlow ? (
            <>
              {t('ring.infoModals.respiratory.subtitle.price_only.a')}
              {CurrencyCode}
              {formatPriceWithComma(
                RespiratoryShopifyMap[store as ShopifyStore].Year1.price,
              )}
              {t('ring.infoModals.respiratory.subtitle.price_only.b')}
            </>
          ) : (
            <>
              {t('ring.infoModals.respiratory.subtitle.a')}
              {CurrencyCode}
              {formatPriceWithComma(
                RespiratoryShopifyMap[store as ShopifyStore].Year1
                  .discountedPrice,
              )}
              {t('ring.infoModals.respiratory.subtitle.b')}
              {CurrencyCode}
              {formatPriceWithComma(
                RespiratoryShopifyMap[store as ShopifyStore].Year1.price,
              )}
              {t('ring.infoModals.respiratory.subtitle.c')}
            </>
          )}
        </p>
        <ImageContainer className="respiratory-container">
          <CustomImage
            src={`web_v2/cart-info-modals/respiratory-mockup-1.png`}
            width={1388}
            height={1133}
            alt={t('ring.infoModals.respiratory.imageAlt')}
            priority
          />
        </ImageContainer>
      </InfoModalTitle>
      <InfoModalDescription>
        <p>{t('ring.infoModals.respiratory.description')}</p>
      </InfoModalDescription>
      <InfoModalDescription>
        <h3>{t('ring.infoModals.respiratory.text.a.title')}</h3>

        <ul>
          <li>
            <p>{t('ring.infoModals.respiratory.text.a.li1')}</p>
          </li>
          <li>
            <p>{t('ring.infoModals.respiratory.text.a.li2')}</p>
          </li>
          <li>
            <p>{t('ring.infoModals.respiratory.text.a.li3')}</p>
          </li>
        </ul>
      </InfoModalDescription>
      <InfoModalDescription>
        <h3>{t('ring.infoModals.respiratory.text.b.title')}</h3>

        <ul>
          <li>
            <p>{t('ring.infoModals.respiratory.text.b.li1')}</p>
          </li>
          <li>
            <p>{t('ring.infoModals.respiratory.text.b.li2')}</p>
          </li>
          <li>
            <p>{t('ring.infoModals.respiratory.text.b.li3')}</p>
          </li>
        </ul>
      </InfoModalDescription>

      {/* <ImageContainer className="screen">
        <CustomImage
          src="web_v2/cart-info-modals/respiratory-2.png"
          width={1388}
          height={798}
          alt="Afib complications"
          priority
        />
      </ImageContainer> */}
    </InfoModalContainer>
  );
};

export const RespiratoryPricingModal = () => (
  <PricingModal>
    <RespiratoryCartInfoModal />
  </PricingModal>
);
